import type { CityConfig } from "../city-template/types";

export const alamogordoConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Alamogordo",
  state: "New Mexico",
  stateAbbr: "NM",
  slug: "alamogordo",
  route: "/cities/alamogordo",
  title: "Emergency Passport Alamogordo, NM — Expedited Same-Day Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Alamogordo, NM — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Holloman AFB personnel, White Sands families, NMSU-A students, and Otero County travelers.",
  h1: "Emergency & Expedited Passport Services in Alamogordo, NM",
  heroSubtitle: "Holloman AFB PCS orders with a fast-approaching report date? Space symposium in Germany and your passport just expired? White Sands National Park international visitors needing documentation? We help Alamogordo residents — from Holloman military families to NMSU-Alamogordo students to Cloudcroft and Tularosa families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Breathtaking%20panoramic%20view%20of%20Alamogordo%20New%20Mexico%20with%20the%20Sacramento%20Mountains%20rising%20dramatically%20in%20the%20background%20at%20golden%20hour%2C%20the%20Tularosa%20Basin%20stretching%20across%20the%20frame%2C%20White%20Sands%20National%20Park%20gypsum%20dunes%20visible%20in%20the%20distance%2C%20desert%20landscape%20with%20yuccas%20and%20creosote%20bushes%20in%20the%20foreground%2C%20warm%20southwestern%20light%20casting%20long%20shadows%2C%20professional%20travel%20photography%20with%20rich%20warm%20desert%20tones&width=1800&height=700&seq=alamogordo-hero-2026&orientation=landscape",
  heroImageAlt: "Alamogordo New Mexico with Sacramento Mountains at golden hour",
  geoPosition: "32.8995;-105.9603",
  geoPlacename: "Alamogordo, New Mexico",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "El Paso Passport Agency",
    address: "700 E San Antonio Ave, Suite 200N, El Paso, TX 79901",
    distance: "Located in downtown El Paso, TX — approximately 90 miles south of Alamogordo. Appointments required, typically booked 2+ weeks out.",
  },
  nearbyCitiesZips: [
    { name: "Alamogordo", zips: "88310, 88311" },
    { name: "Tularosa", zips: "88352" },
    { name: "Cloudcroft", zips: "88317" },
    { name: "La Luz", zips: "88337" },
    { name: "High Rolls", zips: "88325" },
    { name: "Ruidoso", zips: "88345, 88355" },
    { name: "Las Cruces", zips: "88001–88013" },
    { name: "Holloman AFB", zips: "88330" },
    { name: "El Paso (closest agency & airport)", zips: "79901–79999" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Otero County Emergency Processing", desc: "Reserved courier access to the El Paso Passport Agency — just 90 miles south. As fast as 24 hours for Alamogordo-area travelers with immediate departures." },
    { icon: "ri-shield-line", title: "Holloman AFB Military & PCS Support", desc: "Holloman Air Force Base is the largest employer in Otero County. We handle expedited passports for military families with PCS orders, overseas deployments, and short-notice official travel." },
    { icon: "ri-landscape-line", title: "White Sands & Space Industry Ready", desc: "White Sands Missile Range, Spaceport America, and the New Mexico Museum of Space History create unique travel patterns. We understand the aerospace and defense sector's passport timeline requirements." },
    { icon: "ri-flight-takeoff-line", title: "El Paso Airport Gateway", desc: "Alamogordo-White Sands Regional Airport (ALM) offers limited service. Most international travelers drive 90 miles to El Paso International Airport (ELP) — we coordinate passport timing around ELP departures." },
  ],
  internalLinks: [
    { name: "Fast passport services in Las Cruces, NM", route: "/cities/las-cruces" },
    { name: "Expedited passport in El Paso, TX", route: "/cities/el-paso" },
    { name: "Urgent passport services in Albuquerque, NM", route: "/cities/albuquerque" },
    { name: "New Mexico passport services overview", route: "/states/new-mexico" },
  ],
  fpcOfficeAddress: "700 E San Antonio Ave, Suite 200N, El Paso, TX 79901",
  fpcOfficeNote: "Fast Passport Center serves Alamogordo via secure registered courier with direct access to the El Paso Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Alamogordo residents can ship from any UPS Store, FedEx Office, or post office location across Otero County.",
  fpcOfficeDistance: "Serving Alamogordo, Tularosa, Cloudcroft, La Luz, High Rolls, Holloman AFB, and all Otero County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Alamogordo and all of Otero County. From the White Sands Boulevard corridor to the historic downtown district, from the NMSU-A campus area to the residential neighborhoods near the base — we serve the entire Tularosa Basin. Our courier service eliminates the need to drive to El Paso and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Alamogordo and all Otero County communities including Tularosa, Cloudcroft, La Luz, and High Rolls. We also serve Holloman AFB personnel and families, plus nearby communities in Lincoln County (Ruidoso) and Doña Ana County (Las Cruces). El Paso International Airport (ELP) is 90 miles south for international departures.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Alamogordo as simple as possible — with the efficiency and reliability Holloman military families, White Sands personnel, and Otero County residents need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Alamogordo travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Alamogordo travelers encounter unique passport issues — everything from military PCS timeline crunches to mountain community mail delays from Cloudcroft. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Alamogordo travelers — from Holloman AFB families to White Sands engineers to Sacramento Mountain residents — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Alamogordo, NM? Here are the most common ones we hear from Otero County travelers.",
  statePageRoute: "/states/new-mexico",
  statePageName: "New Mexico",
  servicesIntro: "Whether you need a renewal before a PCS move overseas, an emergency passport for a short-notice deployment, or a first-time passport for a family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.oterocountynm.gov/departments/assessor/motor-vehicle/",
  dmvLabel: "Otero County MVD — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Holloman PCS orders with a report date next week? Deployment to an allied nation in 3 days? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Alamogordo-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Alamogordo residents renew fast — no agency visit required for most renewals. Perfect for Holloman families, NMSU-A students, and Otero County professionals preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Alamogordo residents through every step — from White Sands Boulevard to the base — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms including DS-64. We guide you through everything needed to avoid costly mistakes — so your PCS move or White Sands travel is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists — especially important for military families where one parent may be deployed during the application process.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Otero County military spouses after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for White Sands contractors, Holloman personnel, and aerospace industry professionals who travel while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Tularosa Basin travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Convenient for Otero County residents who visit Juarez or cross at Santa Teresa.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Alamogordo NM", description: "Urgent passport processing for Alamogordo New Mexico travelers with immediate departure needs from El Paso Airport." },
    { name: "Expedited Passport Renewal Alamogordo NM", description: "Fast passport renewal for Alamogordo New Mexico residents with a previously-issued passport." },
    { name: "First-Time Passport Alamogordo NM", description: "New passport application services for Alamogordo New Mexico residents applying for their first passport." },
    { name: "Child Passport Alamogordo NM", description: "Minor passport services for Alamogordo New Mexico families with children under 16." },
    { name: "Name Change Passport Alamogordo NM", description: "Passport name correction after marriage, divorce, or legal name changes for Alamogordo residents." },
    { name: "Second Passport Alamogordo NM", description: "Second passport services for Holloman AFB personnel and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "SSgt Michael D.",
      location: "Holloman AFB",
      rating: 5,
      text: "Got PCS orders to Ramstein with a report date in 3 weeks. My family's passports had all expired during COVID. Fast Passport Center handled all five of us — passports arrived in 6 days. The military-specific guidance was spot on.",
      service: "Family Passport Renewal",
    },
    {
      name: "Sarah L.",
      location: "Alamogordo",
      rating: 5,
      text: "I work at White Sands and had a conference in Stuttgart with very short notice. My passport was expired and I was in full panic mode. They got it back in 48 hours. The document review caught an issue with my photo that would have been a rejection.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Reyes Family",
      location: "Tularosa",
      rating: 5,
      text: "We booked a cruise out of Galveston and realized our kids' passports were expired just two weeks before departure. They walked us through the child passport process and everything arrived in 5 days. We made our cruise!",
      service: "Child Passport Renewal",
    },
    {
      name: "Jennifer K.",
      location: "Cloudcroft",
      rating: 5,
      text: "Living up in Cloudcroft, I was worried about the logistics of getting a passport fast. They made it so simple — shipped from the Cloudcroft post office and had my renewal in 7 days. Perfect for mountain residents.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "alam-1",
      name: "Alamogordo Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "900 12th St",
      city: "Alamogordo",
      state: "NM",
      zip: "88310",
      phone: "(575) 437-9035",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Alamogordo",
      website: "https://tools.usps.com/find-location.htm?location=1376530",
      websiteLabel: "USPS Location",
      notes: "Main passport acceptance facility in Alamogordo. Photo services on-site. Serves downtown and the White Sands Boulevard corridor. Appointment strongly recommended — walk-in availability is limited.",
      icon: "ri-mail-line",
    },
    {
      id: "alam-2",
      name: "Holloman AFB Military Personnel Flight",
      type: "Military Passport Office",
      address: "Holloman AFB, Building 224",
      city: "Holloman AFB",
      state: "NM",
      zip: "88330",
      phone: "(575) 572-3940",
      hours: "Mon–Fri 7:30 AM – 4:30 PM (military ID required)",
      distance: "Holloman AFB — on-base only",
      website: "https://www.holloman.af.mil/",
      websiteLabel: "Holloman AFB Website",
      notes: "On-base passport services for active duty, dependents, and DoD civilians with base access. Handles official (no-fee) and tourist passports. Appointment required. Not available to general public.",
      icon: "ri-shield-line",
    },
    {
      id: "alam-3",
      name: "Otero County Clerk — Alamogordo",
      type: "County Clerk Passport Acceptance",
      address: "1104 N White Sands Blvd, Suite C",
      city: "Alamogordo",
      state: "NM",
      zip: "88310",
      phone: "(575) 437-4942",
      hours: "Mon–Fri 8:00 AM – 4:30 PM",
      distance: "Alamogordo — Otero County",
      website: "https://www.oterocountynm.gov/departments/county-clerk/",
      websiteLabel: "Otero County Clerk",
      notes: "Official county clerk passport acceptance facility. Serves all of Otero County. No photo services on-site — bring completed passport photos. Convenient alternative to the post office.",
      icon: "ri-government-line",
    },
    {
      id: "alam-4",
      name: "Tularosa Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "401 Granado St",
      city: "Tularosa",
      state: "NM",
      zip: "88352",
      phone: "(575) 585-2771",
      hours: "Mon–Fri 9:00 AM – 3:00 PM",
      distance: "Tularosa — northern Otero County",
      website: "https://tools.usps.com/find-location.htm?location=1376578",
      websiteLabel: "USPS Location",
      notes: "Serves Tularosa and northern Otero County. Smaller facility with limited hours — call ahead to confirm passport availability. Convenient for Tularosa and La Luz residents.",
      icon: "ri-mail-line",
    },
    {
      id: "alam-5",
      name: "Cloudcroft Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "304 Burro Ave",
      city: "Cloudcroft",
      state: "NM",
      zip: "88317",
      phone: "(575) 682-2431",
      hours: "Mon–Fri 8:30 AM – 2:30 PM",
      distance: "Cloudcroft — Sacramento Mountains",
      website: "https://tools.usps.com/find-location.htm?location=1376535",
      websiteLabel: "USPS Location",
      notes: "Mountain community post office. Very limited hours — confirm passport services before visiting. Best option for Cloudcroft and High Rolls residents who want to avoid driving down to Alamogordo.",
      icon: "ri-mail-line",
    },
    {
      id: "alam-6",
      name: "Las Cruces Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 E Las Cruces Ave",
      city: "Las Cruces",
      state: "NM",
      zip: "88001",
      phone: "(575) 524-2841",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Las Cruces — 70 miles southwest",
      website: "https://tools.usps.com/find-location.htm?location=1376537",
      websiteLabel: "USPS Location",
      notes: "Larger facility within driving distance. Full photo services. Convenient for Alamogordo residents heading to El Paso Airport — can stop in Las Cruces for acceptance on the way. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to El Paso Passport Agency (90 miles)", fpc: "Most Alamogordo travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "NM-Specific Guidance", agency: "Generic — no Holloman, WSMR, or Otero County expertise", fpc: "Full Holloman AFB/White Sands/Otero County knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming Holloman AFB Handles Tourist Passports",
      description: "The on-base Military Personnel Flight primarily handles official no-fee passports. Many military families assume they can get tourist passports there for leisure travel — they usually cannot. We handle tourist and expedited civilian passports.",
    },
    {
      icon: "ri-error-warning-line",
      title: "PCS Timeline Misalignment with Passport Validity",
      description: "Overseas PCS orders often require passports with at least 6 months of validity remaining beyond the tour end date. Military families frequently discover expired passports when orders arrive — we handle urgent renewals fast.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Mountain Community Mail Delays",
      description: "Cloudcroft and High Rolls residents face slower mail delivery than Alamogordo proper. Standard passport processing can take 2-3 extra days due to mountain route delivery. We account for this in our timeline calculations.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent with Deployed Spouse",
      description: "Military families where one parent is deployed face unique challenges with Form DS-3053. We guide you through the notarized consent requirements so your child's application is not rejected.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards at Rural Locations",
      description: "Not all Alamogordo photo providers are equally reliable. We know which locations produce State Department-compliant photos and can advise before you waste time and money on rejected photos.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, base housing, or office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation — military or civilian." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Alamogordo clients ship from the Main Post Office on 12th Street or from home." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to El Paso or wait at the passport agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Alamogordo?", a: "We offer Alamogordo-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Alamogordo?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Alamogordo Post Office or Otero County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Alamogordo address." },
    { q: "Can Holloman AFB personnel use on-base passport services?", a: "The Holloman AFB Military Personnel Flight handles official no-fee passports for PCS and deployment orders. For tourist passports and personal travel, you need civilian passport acceptance. We help military families with both official and civilian passport needs." },
    { q: "Where can I get passport acceptance in Alamogordo?", a: "Alamogordo has acceptance at the Main Post Office (12th Street), the Otero County Clerk (White Sands Blvd), and at Holloman AFB (for military personnel). Tularosa and Cloudcroft also have post office facilities. We maintain an updated list with hours and appointment options." },
    { q: "What is the closest passport agency to Alamogordo?", a: "The closest passport agency is the El Paso Passport Agency at 700 E San Antonio Ave, El Paso, TX — approximately 90 miles south. However, it only serves travelers with life-or-death emergencies. For standard expedited needs, our courier channel is faster and more accessible than driving to El Paso." },
    { q: "What documents do Alamogordo applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide an Alamogordo-specific checklist." },
    { q: "Can you help military families with PCS passport urgencies?", a: "Yes. We regularly assist Holloman AFB families with expedited passports for PCS moves to overseas duty stations. We understand mil-to-mil timelines, command sponsorship requirements, and the unique documentation needs of military families." },
    { q: "How do I get a passport photo in Alamogordo?", a: "The Alamogordo Main Post Office offers photo services on-site. CVS (801 S White Sands Blvd) and Walgreens (744 1st St) also offer passport photos. We recommend confirming photo standards compliance before visiting." },
    { q: "How do I check my passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Alamogordo to final return shipping typically matches your chosen speed tier." },
    { q: "Can you help Cloudcroft residents with passport services?", a: "Yes. We serve all Otero County mountain communities including Cloudcroft, High Rolls, and Mayhill. The Cloudcroft Post Office offers limited passport acceptance — we can advise on the best facility and timeline for mountain residents." },
  ],
  photoLocations: [
    { name: "Alamogordo Main Post Office Photos", address: "900 12th St, Alamogordo, NM 88310", hours: "Mon–Fri 9 AM – 4 PM", website: "https://tools.usps.com/find-location.htm" },
    { name: "Walgreens — Alamogordo", address: "744 1st St, Alamogordo, NM 88310", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Alamogordo", address: "801 S White Sands Blvd, Alamogordo, NM 88310", hours: "Daily 8 AM – 9 PM", website: "https://www.cvs.com/" },
    { name: "Walmart — Alamogordo", address: "233 S New York Ave, Alamogordo, NM 88310", hours: "Daily 6 AM – 11 PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "Otero County MVD — Alamogordo",
      address: "1104 N White Sands Blvd, Suite A, Alamogordo, NM 88310",
      hours: "Mon–Fri, 8:00 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "New Mexico MVD — Alamogordo",
      address: "2400 N Florida Ave, Alamogordo, NM 88310",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Full-service MVD office. REAL ID available. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALM",
      name: "Alamogordo-White Sands Regional Airport",
      distance: "About 4 miles southwest of downtown Alamogordo",
      address: "3500 Airport Rd, Alamogordo, NM 88310",
      note: "Regional airport with limited scheduled service. General aviation and charter flights. Most international travelers use ELP (El Paso) for scheduled departures with connections to DFW, IAH, and PHX.",
      flightUrl: "https://www.ci.alamogordo.nm.us/307/Airport",
      flightLabel: "ALM Airport Website",
      featured: true,
    },
    {
      code: "ELP",
      name: "El Paso International Airport",
      distance: "About 90 miles south of Alamogordo",
      address: "6701 Convair Rd, El Paso, TX 79925",
      note: "Closest major international airport. Serves the Borderland region with connections to DFW, IAH, PHX, DEN, and LAX for international gateways. Primary airport for Otero County international travelers.",
      flightUrl: "https://www.elpasointernationalairport.com/",
      flightLabel: "ELP Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New Mexico Department of Health. Online, mail, or in-person options available for Otero County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NM Department of Health Vital Records. Required for estate and legal matters in Otero County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Otero County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.oterocountynm.gov/departments/county-clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Twelfth Judicial District Court. Required for name change passport corrections.",
      url: "https://twelfthdistrictcourt.nmcourts.gov/",
    },
  ],
};